'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Streamdown } from 'streamdown';
import { componentsOverrides } from './markdown-components';
interface MarkdownProps {
  children: string;
  className?: string;
}
function Markdown(t0) {
  const $ = _c(6);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("text-xs/4.5 sm:text-sm/5.5 xl:text-base/6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      code: true,
      table: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1) {
    t3 = <Streamdown className={t1} components={componentsOverrides} controls={t2}>{children}</Streamdown>;
    $[3] = children;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export { Markdown };